import { createAction } from 'redux-actions';

export default {
  setLoading: createAction('loading/SET_LOADING'),
  unsetLoading: createAction('loading/UNSET_LOADING'),
};
